// RU: звук игры — только то, что играют игра и ядро. Звуков джекпота и колеса (boosted jackpot)
//     нет: джекпот — слой платформы. `AmountIncrease` и тиры Big Win играет ядро.
const sound = (name, file, options = {}) => ({
  src: `game/sounds/${file}.mp3`,
  path: `game/sounds/${file}.mp3`,
  name,
  autoplay: false,
  html5: true,
  ...options,
});

export const soundResources = [
  sound('ReelStop', 'reelStop'),
  sound('ReSpinTextSound', 'reSpinText'),
  sound('SpinButton', 'spinButton'),
  sound('WildSymbol', 'wildSymbol'),
  sound('WildOpeningSound', 'wildOpeningSound'),
  sound('WinningLineSound', 'winningLineSound'),
  sound('AmountIncrease', 'amountIncrease'),
  sound('BigWinSound', 'bigWinSound'),
  sound('MegaWinSound', 'megaWinSound'),
  sound('SuperWinSound', 'superWinSound'),
  sound('EpicWinSound', 'epicWinSound'),
  sound('MaxWinSound', 'maxWinSound'),
  sound('BackgroundMusic', 'backgroundMusic', { autoplay: true, loop: true }),
];
